export const AdminNotificationsDataLayerSymbol = Symbol.for("AdminNotificationsDataLayerSymbol");
